import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/queries/utils";
import { Conversation } from "@/queries/venturi/venturi-job-chat";

export const useSendVenturiJobChatMessage = (chatId: string, jobId: string) => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (message: string) => {
      const token = await getAccessTokenSilently();

      return request<string>({
        method: "POST",
        path: `/api/admin/job_opening/${jobId}/venturi_chat/${chatId}`,
        token,
        body: JSON.stringify({
          message,
        }),
      });
    },
    onMutate: (variables) => {
      // Fetch any existing data for the job updated
      const prev = qc.getQueryData<Conversation>(
        QueryKeys.venturiJobChat(chatId),
      );

      if (prev) {
        if (prev.initialized) {
          // Update the data
          qc.setQueryData<Conversation>(QueryKeys.venturiJobChat(chatId), {
            ...prev,
            messages: [
              ...prev.messages,
              {
                from: "User",
                message: variables,
              },
            ],
          });
        } else {
          // Update the data
          qc.setQueryData<Conversation>(QueryKeys.venturiJobChat(chatId), {
            ...prev,
            initialized: true,
          });
        }
      }
    },
    onSuccess: (data) => {
      // Fetch any existing data for the job updated
      const prev = qc.getQueryData<Conversation>(
        QueryKeys.venturiJobChat(chatId),
      );

      if (prev) {
        // Update the data
        qc.setQueryData<Conversation>(QueryKeys.venturiJobChat(chatId), {
          ...prev,
          messages: [
            ...prev.messages,
            {
              from: "Bot",
              message: data,
            },
          ],
        });
      }
    },
  });

  return {
    sendVenturiJobChatMessage: mutate,
    isSendingVenturiJobChatMessage: isPending,
    sendVenturiJobChatMessageError: error,
  };
};
